"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const Yup = __importStar(require("yup"));
const DispatchContext_1 = require("../context/DispatchContext");
const Button_1 = __importDefault(require("../elements/Button"));
const Label_1 = __importDefault(require("../elements/Label"));
const FormikCheckBox_1 = __importDefault(require("../elements/formik/FormikCheckBox"));
const Alert_1 = require("../elements/popup/Alert");
const useCheckPointsNumberInWindowArea_1 = require("../hooks/useCheckPointsNumberInWindowArea");
const Header_1 = require("./Header");
const HeaderContainer_1 = require("./HeaderContainer");
const FormikInput_1 = __importDefault(require("../elements/formik/FormikInput"));
const validationSchema = Yup.object().shape({
    minMaxRatio: Yup.number().min(0).required(),
});
const initialValues = {
    minMaxRatio: 0.05,
    lookNegative: false,
};
function RangesPickingOptionPanel() {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const pointsNumber = (0, useCheckPointsNumberInWindowArea_1.useCheckPointsNumberInWindowArea)();
    const alert = (0, Alert_1.useAlert)();
    function handleRangesPicking(values) {
        if (pointsNumber > useCheckPointsNumberInWindowArea_1.MIN_AREA_POINTS) {
            dispatch({
                type: 'AUTO_RANGES_DETECTION',
                payload: values,
            });
        }
        else {
            alert.error(`Auto range picking only available for area more than ${useCheckPointsNumberInWindowArea_1.MIN_AREA_POINTS} points`);
        }
    }
    return ((0, jsx_runtime_1.jsx)(HeaderContainer_1.HeaderContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { onSubmit: handleRangesPicking, initialValues: initialValues, validationSchema: validationSchema, children: ({ handleSubmit, isValid }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "Detect negative:", htmlFor: "lookNegative", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "lookNegative" }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Min Max Ratio:", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { type: "number", name: "minMaxRatio", style: {
                                input: {
                                    width: '70px',
                                    textAlign: 'center',
                                },
                                inputWrapper: { height: '100%' },
                            }, step: 0.01, min: 0 }) }), (0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: () => handleSubmit(), style: { margin: '0 10px' }, disabled: !isValid, children: "Auto ranges picking" })] })) }) }));
}
exports.default = RangesPickingOptionPanel;
